(function() {
  const secondaryMenuLinks = document.querySelectorAll('.secondary-menu__link');
  const imageWithTextSections = document.querySelectorAll('.image-with-text');
  const headerHeight = document.querySelector('.header-wrapper').offsetHeight;
  const secondaryMenuHeight = document.querySelector('.secondary-menu').offsetHeight;

  const removeActiveClass = () => {
    secondaryMenuLinks.forEach((link,i) => {
      link.classList.remove('active');
    })
  };
  
  secondaryMenuLinks.forEach((link,i) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const scrollOffset = headerHeight + secondaryMenuHeight;
      const targetElement = imageWithTextSections[i];
      const targetElementOffsetTop = targetElement.offsetTop;
      removeActiveClass();
      link.classList.add('active');
      window.scrollTo({
        top: targetElementOffsetTop - scrollOffset,
        behavior: 'smooth'
      });
    });
  });
})();